import { render, staticRenderFns } from "./uprate.vue?vue&type=template&id=cec99412&scoped=true&"
import script from "./uprate.vue?vue&type=script&lang=js&"
export * from "./uprate.vue?vue&type=script&lang=js&"
import style1 from "./uprate.vue?vue&type=style&index=1&id=cec99412&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec99412",
  null
  
)

export default component.exports